module.exports = __webpack_public_path__ + "assets/img/flag-ua.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flag-ua.png
// module id = 58
// module chunks = 0